import { styles } from './template.scss';
import { styles as customCommonStyles } from '../../common.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';

export const templateLicenseMonthlyServicesForm = document.createElement('template');

templateLicenseMonthlyServicesForm.innerHTML = `
  <style>${commonStyles}</style>
  <style>${customCommonStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${styles}</style>

  <div id='wrapper'>
    <section id='mdr-form-field-section'>
      <div class='in-trial-text'>
        <gz-toggle id='additional-managed-detection-and-response-form-field' hidden gz-form-input placeholder=''></gz-toggle>
        <div id='mdr-trial-started-text' class='hidden trial-started-text'>
        </div>
      </div>
      <span id='managed-detection-and-response-service-status' hidden></span>
      <gz-text fontSize="11" id='service-parent-company-mdr-contact-info-required'>
      </gz-text>
    </section>

    <section class='subform-section hidden'>
      <gz-radio-group gz-form-input id='mdr-advice-flavours-group' selectedOption="" hidden disabled>
        <gz-radio class='pl-5 mt-1' id='mdr-advice-form-field'></gz-radio>
      </gz-radio-group>
    </section>
  </div>
`;
